import {
    mailListItemAnimationStore,
    clearAnimationStore,
    ActionId,
} from 'owa-mail-list-item-animation-store';

import { setAnimationAction } from 'owa-mail-list-item-animation-store/lib/actions/setAnimationAction';
import { getNextActionId } from './getNextActionId';

export function handleAnimationComplete(animationAction: ActionId, rows: Element[]) {
    if (animationAction == 'PinInitial' || animationAction == 'UnpinInitial') {
        rows.forEach(row => {
            if (mailListItemAnimationStore.animationRowIds.has(row.id)) {
                (row as HTMLDivElement).style.background = 'transparent';
            }
        });
        setAnimationAction(
            getNextActionId(animationAction),
            Array.from(mailListItemAnimationStore.animationRowIds),
            mailListItemAnimationStore.onAnimationComplete
        );
    } else if (animationAction == 'PinMiddle' || animationAction == 'UnpinMiddle') {
        setAnimationAction(
            getNextActionId(animationAction),
            Array.from(mailListItemAnimationStore.animationRowIds)
        );
    } else if (
        animationAction == 'PinFinal' ||
        animationAction == 'UnpinFinal' ||
        animationAction == 'AddRowFinal'
    ) {
        clearAnimationStore();
    } else if (animationAction == 'AddRowInitial') {
        setAnimationAction(
            getNextActionId(animationAction),
            Array.from(mailListItemAnimationStore.animationRowIds)
        );
    } else {
        rows.forEach(row => {
            if (mailListItemAnimationStore.animationRowIds.has(row.id)) {
                (row as HTMLDivElement).style.opacity = '0';
            }
        });
        mailListItemAnimationStore.onAnimationComplete?.();
        clearAnimationStore();
    }
}
